export default __webpack_public_path__ + "static/media/stock-management.bfb54127.svg";